import React from 'react';
import { Link } from 'gatsby';
import config from '../../config';
export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="row">
          <div className="col-4">
            <h4>Quick Links</h4>
            <ul className="list-inline">
              <li className="list-inline-item">
                <a href="#">Support</a>
              </li>
              <li className="list-inline-item">
                <a href="#">Help Center</a>
              </li>
              <li className="list-inline-item">
                <Link to="/privacy">Privacy Policy</Link>
              </li>
              <li className="list-inline-item">
                <Link to="/tos">Terms of Service</Link>
              </li>
            </ul>
          </div>
          <div className="col-4">
            <h4>About our mission</h4>
            <p>We are spearheading a data-driven revolution in mental healthcare through software, training, and research. Join us!</p>
          </div>
          <div className="col-4">
            <h4>100% Secure, Forever</h4>
            <p>This site meets rigorous standards for digital privacy and security. It is maintained with love by your friends at Healify, Inc.</p>
          </div>
        </div>
      </div>
    </footer>

  );
}
